import * as React from 'react'
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
} from '@mui/material'
import { useSelector } from 'react-redux';

function ProfileSettings() {
  const user = useSelector(state => state.auth.user);

  return (
    <Box>
      <Typography 
        variant="h5" 
        sx={{ 
          fontWeight: 600,
          marginBottom: '32px',
          color: '#2A3547'
        }}
      >
        Account Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="First & Last Name"
            value={user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}` : ''}
            disabled
            sx={{ marginBottom: '16px' }}
          />
          <TextField
            fullWidth
            label="Job Title"
            value={user?.job_title || ''}
            disabled
            sx={{ marginBottom: '16px' }}
          />
          <TextField
            fullWidth
            label="User Name"
            value={user?.username || user?.email || ''}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Email"
            value={user?.email || ''}
            disabled
            sx={{ marginBottom: '16px' }}
          />
          <TextField
            fullWidth
            label="Account Type"
            value={user?.role || user?.role_name || ''}
            disabled
            sx={{ marginBottom: '16px' }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
            <Button
              variant="outlined"
              sx={{
                borderColor: '#ff9800',
                color: '#ff9800',
                '&:hover': {
                  borderColor: '#f57c00',
                  backgroundColor: 'rgba(255, 152, 0, 0.04)',
                },
                textTransform: 'none',
                padding: '8px 24px',
              }}
            >
              Reset Password
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ProfileSettings;
